import { Routes } from '@angular/router';

// No routing - application uses direct component inclusion (matches readonly license app)
export const routes: Routes = [];
